import { logoStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsLogo";
import { css } from "styled-components";

Object.assign(logoStyles, {
    ...logoStyles,
    image: {
        css: css`
            width: 100%;
            img {
                max-width: 300px;
                max-height: 300px;
            }
        `,
    },
});
